export default function Copy (){
    return(<div className="divcopy"><h2 className="copy">© 2025 H2L Engenharia.</h2></div>)
}